import classNames from "classnames";
import React, { FC } from "react";
import { BsFacebook } from "react-icons/bs";
import ShareIcon from "./ShareIcon";

type FacebookShareIconProps = {
  color?: string;
};
const FacebookShareIcon: FC<FacebookShareIconProps> = ({ color }) => {
  const style: any = { height: "30px", width: "30px" };
  if (color) style.color = color;

  return (
    <ShareIcon
      className={classNames("text-indigo-900")}
      urlPrefix="https://www.facebook.com/sharer/sharer.php?u="
    >
      <BsFacebook style={style} />
    </ShareIcon>
  );
};

export default FacebookShareIcon;
